//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VideoContainer",
  props: {
    src: {
      type: String,
      required: true
    },
    headline: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  methods: {
    isMP4() {
      return this.src.toLowerCase().endsWith('mp4')
    }
  },
  mounted() {
    console.log("Video mounted", this.src)
  }
}
